<ng-container *ngLet="clusterLoading$ | async as loading">

<ng-container *ngLet="geoDistrictArea$ | async">
  <div *ngLet="breakPointObserve$ | async"
       class="relative-container"
       [class.full-screen-map]="isFullscreen"
       [class.disable-map]="loading"
       #relativeContainer>
    <div *ngLet="geoDataArea$ | async" [id]="mapElementId" class="map-container"></div>

    @if (showFilterMenu) {
      <div class="top-menu-container">
        <ng-container *ngLet="clickRecommendation$ | async">
          <span [class.element-disabled]="isNotPublicCatalog">
            @if (!dynamicDataSet) {
              <mat-checkbox
                [disabled]="isNotPublicCatalog"
                class="recommended mr32"
                [matTooltip]="'DATA.TABLE_FILTER.RECOMMENDED' | translate"
                [(ngModel)]="isRecommendationData"
                (click)="getRecommendationClick(!isRecommendationData)"
              >{{ 'DATA.CATALOG_ITEMS_DATA.HEADER.RECOMMENDED' | translate }}</mat-checkbox>
            }
          </span>
        </ng-container>

        <div [formGroup]="form" class="container__next-me" [class.element-disabled]="isNotPublicCatalog">
          <mat-checkbox
            formControlName="isNextMeData"
            [matTooltip]="'DATA.CATALOG_ITEMS_DATA.HEADER.NEARBY' | translate"
          >
            {{ 'DATA.CATALOG_ITEMS_DATA.HEADER.NEARBY' | translate }}
          </mat-checkbox>
          <div class="input__container">
            <input
              (keydown.enter)="getNextMeData()"
              [matTooltip]="'OTHER.RADIUS' | translate"
              formControlName="radius"
              class="input__next-me"
              placeholder="2000"
              type="text"
              min="0"
            />
            <div class="buttons-wrapper">
              <button
                [matTooltip]="'DATA.TABLE_FILTER.SEARCH' | translate"
                [disabled]="!nextMeData.isNextMeData"
                class="btn-empty search-btn"
                (click)="getNextMeData()"
              >
                <svg [icon]="icons.Search" class="svg24 inactive-color search-icon" />
              </button>
            </div>
          </div>
        </div>
        <app-search-filter
          [hasBorder]="true"
          (changedFilter)="changeFilter($event)"
          [overlayPosition]="filterOverlayPosition"
          [allFields]="allColumns$ | async"
          [class.disabled]="isRecommendationDisabled"
        ></app-search-filter>
      </div>
    }

    @if (showDynamicInfo) {
      <app-dynamic-update-info class="dynamic-info-pc"></app-dynamic-update-info>
    }

    @if (showZoomControl) {
      <div [class.impaired]="isImpaired" [class.right-control]="controlRight" class="controls">
        <div class="zoom mb12">
          @if (hasMapZoom) {
            <button
              [disabled]="map.getZoom() === maxMapZoom"
              class="btn-empty zoom-control"
              matTooltip="{{ 'OTHER.INCREASE' | translate }}"
              (click)="changeZoom$.next(1)"
              type="button"
            >
              <svg [icon]="icons.Plus" class="svg24 dark-gray-color" />
            </button>

            <button
              [disabled]="map.getZoom() === 9"
              class="btn-empty zoom-control"
              matTooltip="{{ 'OTHER.DECREASE' | translate }}"
              (click)="changeZoom$.next(-1)"
              type="button"
            >
              <svg [icon]="icons.Minus" class="svg24 dark-gray-color" />
            </button>
          }
        </div>
        <button class="reset-zoom btn-empty zoom-control mb12" matTooltip="{{ 'OTHER.CENTER' | translate }}" (click)="resetZoom()" type="button">
          <svg [icon]="isImpaired ? icons.Search : icons.DefaultMapZoom" class="svg24 dark-gray-color" />
        </button>

        <button
          class="reset-zoom btn-empty zoom-control mb12"
          matTooltip="{{ 'OTHER.MY_LOCATION' | translate }}"
          (click)="setMyLocation()"
          type="button"
        >
          @if (showMyPosition) {
            <svg [icon]="icons.MyLocation" class="primary-color-60 svg24" />
          } @else {
            <svg [icon]="icons.MyLocation" class="dark-gray-color svg24" />
          }
        </button>

        @if (map && mapRotation !== 0) {
          <button
            class="reset-zoom btn-empty zoom-control rotation-map"
            matTooltip="{{ 'OTHER.CENTER' | translate }}"
            (click)="setRotationMap()"
            type="button"
          >
            <svg [icon]="icons.OrientationMap" class="svg24 dark-gray-color" />
          </button>
        }
      </div>
    }

    @if (showFullScreenButton) {
      <div class="mobile-controls">
        <button class="reset-zoom btn-empty zoom-control" (click)="toggleFullscreen()">
          <svg
            [icon]="!isFullscreen ? icons.FullScreen : icons.FullScreenNon"
            class="svg24 dark-gray-color"
            [matTooltip]="(!isFullscreen ? 'OTHER.FULL_SCREEN' : 'OTHER.NORMAL_SCREEN') | translate"
          ></svg>
        </button>
      </div>
    }

    @if (showDynamicInfo) {
      <app-dynamic-update-info [isMobile]="true" class="mobile-dynamic-info"></app-dynamic-update-info>
    }

    @if (showCopyrights) {
      <div class="copyright-wrapper">
        <a class="copyright-button"
           [class.show-text]="showCopyrightsText"
           [class.is-fullscreen-on-seasonal]="isFullScreenOnSeasonal"
           href="http://dev.2gis.ru"
           target="_blank"
        ></a>
      </div>
    }
  </div>
</ng-container>

  @if (loading) {
    <div class="loader-container">
      <app-loader></app-loader>
    </div>
  }
</ng-container>
